import React from 'react';
import styled from 'styled-components';
import PhoneInput from 'react-phone-number-input';
import { theme } from '../../assets/styles/theme';

const Container = styled.div`
  position: relative;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledPhoneInput = styled(PhoneInput)`
  &.PhoneInput {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 12px;
    gap: 10px;
    height: 45px;
    background: ${theme.color.lighterGray};
    color: ${theme.color.lightBlack};
    border: 1px solid ${theme.color.lighterGray};
    border-radius: 5px;
    box-shadow: unset;
  }

  & input {
    display: flex;
    align-items: center;
    border: none;
    outline: 0;
    background: inherit;
    width: 100%;
  }

  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }

  .PhoneInputCountry {
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
  }

  .PhoneInputCountryIconImg {
    width: 36px;
  }

  .PhoneInputCountrySelectArrow {
    display: block;
    width: 8px;
    height: 8px;
    border: 2px solid ${theme.color.darkerGray};
    border-top-width: 0;
    border-left-width: 0;
    transform: rotate(45deg);
  }
`;

interface Props {
  onChange: (value: string) => void;
  value: string;
  className?: string;
}

const PhoneNumberInput = ({ value, onChange, className }: Props) => {
  return (
    <Container className={className}>
      <StyledPhoneInput
        international={true}
        defaultCountry={'US'}
        limitMaxLength={true}
        value={value}
        onChange={onChange}
        addInternationalOption={false}
        countryCallingCodeEditable={true}
      />
    </Container>
  );
};

export default PhoneNumberInput;
